module.exports = __webpack_public_path__ + "img/kd.9c924b1d.png";